import * as React from 'react';
import { manageOptionsButtonWrapper } from 'app/components';

export const withManageOptions = (WrappedComponent: React.ComponentType) => {

  return (props: any) => {
    const {manageOptions, textManageOptions, extraFooterButton, disableManageOptions} = props;
    const manageOptionsButton = !disableManageOptions && 
      (extraFooterButton || manageOptionsButtonWrapper(manageOptions, textManageOptions));

    return <WrappedComponent {...props} extraFooterButton= {manageOptionsButton} />;    
  };
};
